import { ScriptDef, ScriptTheme } from '../../types';

export const TV_ZHIYE_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_037',
        name: '首席口译',
        genre: 'tv',
        synopsis: '高翻院学员骆清圆靠一份精心包装的履历入学：速成班的结业证书写成了两年科班，实习译员的头衔放大成了随团翻译。偏偏院里把她和全院出了名的“不装派”教员傅司远编成一组，接一个高规格代表团的随团口译任务。魔鬼训练照旧，骆清圆真正的难关不是傅司远，是拆掉自己那页包装出来的履历，用真水平坐进同传箱。',
        roles: [
            {
                name: '骆清圆',
                roleType: '女主角',
                billing: 1,
                intro: '高翻院学员，履历注水的“包装选手”，真功夫只剩一半。她的笔记本正页记专业词汇，副页记自己撒过的谎。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '傅司远',
                roleType: '男主角',
                billing: 1,
                intro: '高翻院教员，全院出了名的“不装派”，口头禅是“重译”。他第一天就看出了骆清圆的水分，没有点破，只把最难的材料一份份推到她面前。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '边树',
                roleType: '男二号',
                billing: 2,
                intro: '猎头顾问，专替学员“包装履历”的中介方，骆清圆当年经他手办的手续。他后来想挖骆清圆去商业译场赚快钱，被她当着他的面撕了简历。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, wisdom: 2 },
            },
            {
                name: '言枝',
                roleType: '女二号',
                billing: 2,
                intro: '骆清圆的室友兼同门，立志进部委，挂科边缘疯狂蹦迪——却是全院唯一裸分考进来的。她是第一个知道骆清圆履历秘密的人，保密费是每天一顿早餐。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, charm: 2 },
            },
            {
                name: '小唐',
                roleType: '女配角',
                billing: 5,
                intro: '高翻院的教务助理，每天替教员们打印、装订训练材料，谁的稿子改到第几版她都记得。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Occupation, ScriptTheme.Urban],
        heat: 41,
        baseScore: 5.7,
    },
    {
        id: 'SCRIPT_038',
        name: '金牌法务',
        genre: 'tv',
        synopsis: '法学生佟佳音毕业赶上律所缩编，进泓正律所的第一个岗位是资料室管理员，给全所卷宗编页码。她用下班时间啃下法考，拿到执业资格后转进诉讼组，跟着带新人出了名严格的合伙人霍正霆办案。闺蜜的租房纠纷指名要她代理，她按执业规范申请回避。所内两派争夺管理合伙人，霍正霆被诬陷泄露客户信息，佟佳音凭着编页码记住的卷宗流转记录找出时间戳漏洞。风波平息，公示栏上她的名字第一次出现在“执业律师”一栏。',
        roles: [
            {
                name: '霍正霆',
                roleType: '男主角',
                billing: 1,
                intro: '泓正律所高级合伙人，胜诉率全所第一，带新人出了名的严：法条背不全不准进会议室。他的办公室书架上不摆装饰书，全是手写过结案日期的卷宗。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '佟佳音',
                roleType: '女主角',
                billing: 1,
                intro: '资料室出身的执业律师，考了四年才通过法考，如今背法条比背歌词快，接案先翻执业规范。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '柏克礼',
                roleType: '男二号',
                billing: 2,
                intro: '同所律师，嘴上抢功一世，反被对家挖角两次都没走。他替佟佳音接下她该回避的那桩闺蜜案，办得尽心尽力。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 2 },
            },
            {
                name: '米兰',
                roleType: '女二号',
                billing: 2,
                intro: '霍正霆的行政秘书，情商天花板，全所八卦中转站。日程本精确到分钟，两派争夺管理合伙人期间，她谁的会都排得开、谁的话都不往外传。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Occupation, ScriptTheme.Urban],
        heat: 38,
        baseScore: 5.3,
    },
    {
        id: 'SCRIPT_039',
        name: '热搜救火队',
        genre: 'tv',
        synopsis: '明星艺人塌房频发的年份，临海市最神秘的公关公司“救火队”生意火爆，创始人龙奕是行业公认的“公关之神”，据说没有他压不下去的热搜。实习生乔安然入职第一天就撞上顶流失恋退网、品牌方集体解约、竞对泼脏水三连危机，龙奕带她通宵作战，一晚撤下七个热搜。此后求婚翻车、直播口误、顶流恋情曝光等危机接连不断，龙奕逢战必胜，乔安然逢战必学。年度复盘会上，龙奕把“年度最佳新人”颁给乔安然，理由是她救了所有人的热搜。',
        roles: [
            {
                name: '龙奕',
                roleType: '男主角',
                billing: 1,
                intro: '公关公司创始人，江湖人称“热搜灭火器”，声明稿从不超过一百字。他把三十七套危机预案按行业分册归档，从不承认其中任何一套是通用的。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '乔安然',
                roleType: '女主角',
                billing: 1,
                intro: '实习生，入职半年独立操盘大型舆情，被破格提拔为全公司最年轻的客户总监。她的笔记本第一页写着龙奕的话：热搜不是敌人，是没接对电话。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '曹之洋',
                roleType: '女二号',
                billing: 2,
                intro: '竞对公司资深公关，龙奕的宿敌兼旧识，七次交锋皆负。第七次败诉当晚，她带着半支团队加入了龙奕的公司，从对手席搬到了他的右手边。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, wisdom: 2 },
            },
            {
                name: '傅嘉珺',
                roleType: '男二号',
                billing: 2,
                intro: '顶流艺人的经纪人，救火队最大的客户来源。他谈续约合同时从不见艺人本人，只跟对方的团队谈风险预案。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Occupation, ScriptTheme.Urban],
        heat: 32,
        baseScore: 4.5,
    },
    {
        id: 'SCRIPT_084',
        name: '守夜人',
        genre: 'tv',
        synopsis: '城南消防中队辖区没有高层商圈，全是老旧小区和城中村。中队长严恪十年没遇过大火，日常处置的是猫困树上、老人反锁、煤气泄漏。新分配来的体校生佟野嫌没有用武之地，第一次出警就把破门斧落在了现场。严恪带着四个徒弟，处理了一年没上过一次新闻的警情。冬至那天中队包饺子，火警铃响了，是佟野第一次独自带车出警。',
        roles: [
            {
                name: '严恪',
                roleType: '男主角',
                billing: 1,
                intro: '消防中队长，十年老消防。出警前必检查每个人的装备，被中队叫"严妈"。办公桌抽屉里有一沓手写的出警复盘，每页标注耗时和失误。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2, wisdom: 2 },
            },
            {
                name: '佟野',
                roleType: '男二号',
                billing: 2,
                intro: '新入职消防员，体校毕业，体能全优。第一次出警破门把斧子落在了现场，被严恪罚抄了一个月的水带型号。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, stamina: 3, charm: 2 },
            },
            {
                name: '方晴',
                roleType: '女配角',
                billing: 3,
                intro: '严恪妻子，医院烧伤科护士。从不看严恪的出警视频，但每次有爆炸警情都会刷新中队的在线状态。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '店员',
                roleType: '女配角',
                billing: 5,
                intro: '中队对面便利店的店员，每天上夜班，消防车出警时她会站在门口数出去几辆、回来几辆。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Occupation, ScriptTheme.SeriousDrama],
        heat: 56,
        baseScore: 8.4,
    },
    {
        id: 'SCRIPT_085',
        name: '柳叶刀',
        genre: 'tv',
        synopsis: '东江医院新设心脏中心，心外副主任钟岐与心内介入医生裴让被编入同一治疗组。钟岐信奉开胸手术的彻底性，裴让主张微创介入优先，两台手术之间的方案分歧从会诊室吵到手术室门口。钟岐的母亲周慧当年是该院护士，因一起用药争议被迫离职。裴让的导师恰好是当年事件的评审委员。一台主动脉夹层手术让两人的冲突达到顶点，也让十五年前的用药争议重新浮出水面。',
        roles: [
            {
                name: '钟岐',
                roleType: '男主角',
                billing: 1,
                intro: '心外副主任医师，手术刀稳但脾气硬。查房时只问数据不问感受，被病人叫"冰块"。办公室墙上挂着一张旧照片，是他母亲在护士站的合影。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '裴让',
                roleType: '男二号',
                billing: 2,
                intro: '心内介入医生，海外进修归来。笃信微创优先，认为钟岐的开胸方案是"用大炮打蚊子"。每次术前谈话都先给家属看解剖图。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '方筱宁',
                roleType: '女主角',
                billing: 2,
                intro: '急诊科主任，钟岐和裴让之间的缓冲带。她的原则是"病人活着到手术台比谁主刀更重要"。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '小何',
                roleType: '女配角',
                billing: 5,
                intro: '急诊科轮转护士，负责推急救箱。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Occupation, ScriptTheme.SeriousDrama, ScriptTheme.LifeStyle],
        heat: 55,
        baseScore: 8.2,
    },
];
